import React from 'react';
import './MOQWidget.scss';
import { IMOQValidationResponse } from '../../api/MOQ/IMOQValidationResponse';

interface IMOQWidgetProps {
  moqValidation?: IMOQValidationResponse;
  basketItemCount: number;
  combinedOrder: boolean;
}

const MOQWidget: React.FC<IMOQWidgetProps> = ({ moqValidation, basketItemCount, combinedOrder }) => {
  if (!moqValidation || !moqValidation.isMoqApplicable) {
    return null;
  }

  const hasItems = basketItemCount > 0;

  const getTextColor = (status: string, current: number): string => {
    if (current === 0) return 'black';
    if (status === 'Success') return 'green';
    return 'red';
  };

  const getOverallRoundelColor = (): string => {
    if (!hasItems) return 'red';
    return moqValidation.overallStatus === 'Success' ? 'green' : 'red';
  };

  const formatNumber = (value: number): string => {
    return Number.isInteger(value) ? value.toString() : value.toFixed(2);
  };

  const renderMOQDisplay = () => {
    const isCustomerLevel = moqValidation.levelType === 'customer';

    const hasValidMOQData = isCustomerLevel
      ? moqValidation.day
      : (moqValidation.categories && moqValidation.categories.length > 0);

    if (!hasValidMOQData) {
      return null;
    }

    return (
      <div className="moq-display-container">
        <div style={{ fontSize: '14px', fontWeight: 'bold', color: 'black', textAlign: 'center' }}>
          MOQ
        </div>

        {isCustomerLevel ? (
          moqValidation.day && (
            <div
              style={{
                color: getTextColor(moqValidation.day.status, moqValidation.day.current),
                fontSize: '14px',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              {formatNumber(moqValidation.day.current)} / {formatNumber(moqValidation.day.required)}
            </div>
          )
        ) : (
          moqValidation.categories && moqValidation.categories.length > 0 && (
            <div className="moq-categories">
              {combinedOrder ? (
                moqValidation.categories.filter(category => category.current > 0).map((category, index) => (
                  <div
                    key={index}
                    className="moq-category"
                    style={{
                      color: getTextColor(category.status, category.current),
                      fontSize: '14px',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    {category.categoryCode} {formatNumber(category.current)} / {formatNumber(category.required)}
                  </div>
                ))
              ) : (
                <div
                  style={{
                    color: getTextColor(moqValidation.categories[0].status, moqValidation.categories[0].current),
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {formatNumber(moqValidation.categories[0].current)} / {formatNumber(moqValidation.categories[0].required)}
                </div>
              )}
            </div>
          )
        )}
      </div>
    );
  };

  return (
    <div className="moq-widget">
      <div className="moq-content">
        {renderMOQDisplay()}
      </div>
    </div>
  );
};

export default MOQWidget;
